export type RequestGuard = () => boolean

export function createLatestRequestGuard() {
  let latestRequest = 0

  return {
    begin(): RequestGuard {
      const request = ++latestRequest
      return () => request === latestRequest
    },
    invalidate() {
      latestRequest += 1
    },
  }
}
